import { parseIncomeYen, SPOUSE_INCOME_LIMIT } from '../dependentDeduction/spouseSection/spouseEligibility';
import type { FamilyMemberDraft, YesNo } from './familyInfoTypes';

export type SpouseFamilyIneligibilityReason =
  | 'no_shared_livelihood'
  | 'spouse_family_worker'
  | 'spouse_income_over_limit'
  | '';

/** Derive withholding eligibility from Family Info spouse answers (employee income checked in Section 2). */
export function deriveSpouseWithholding(d: FamilyMemberDraft): {
  withholdingSpouse: YesNo;
  taxEligible: YesNo;
  ineligibilityReason: SpouseFamilyIneligibilityReason;
} {
  if (d.relationship !== 'spouse' || d.claimTaxDependent !== 'yes') {
    return { withholdingSpouse: '', taxEligible: '', ineligibilityReason: '' };
  }
  if (d.sharedLivelihood === 'no') {
    return { withholdingSpouse: 'no', taxEligible: 'no', ineligibilityReason: 'no_shared_livelihood' };
  }
  if (d.spouseFamilyWorker === 'yes') {
    return { withholdingSpouse: 'no', taxEligible: 'no', ineligibilityReason: 'spouse_family_worker' };
  }
  if (parseIncomeYen(d.estimatedIncome) > SPOUSE_INCOME_LIMIT) {
    return { withholdingSpouse: 'no', taxEligible: 'no', ineligibilityReason: 'spouse_income_over_limit' };
  }
  if (d.sharedLivelihood === 'yes' && d.spouseFamilyWorker === 'no' && d.estimatedIncome.trim()) {
    return { withholdingSpouse: 'yes', taxEligible: 'yes', ineligibilityReason: '' };
  }
  return { withholdingSpouse: '', taxEligible: '', ineligibilityReason: '' };
}

export function isSpouseTaxFlow(d: FamilyMemberDraft): boolean {
  return d.relationship === 'spouse' && d.claimTaxDependent === 'yes';
}
